import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    className: 'bold',
    render: function (data, type, row, meta) {
      return renderToString(<div>
        <span>{data}</span><br />
        {row['default'] === 'true' && <span className='small-text'>This is your default email sender</span>}
      </div>)
    },
  },
  { data: 'email', render: (data) => renderToString(<span>{data}</span>) },
  {
    data: 'id',
    className: 'right',
    render: (data) => `
      <button class="button edit-email-sender-button" data-id="${data}">Edit</button>
      <button class="button delete-email-sender-button" data-id="${data}">Delete</button>
    `,
  },
]

const headers = [
  'Name',
  'Email',
  '',
]

const filters = [
]

const sorters = [
]

const order = [[ 1, "asc" ]]

export { columns, headers, filters, sorters, order }
